import { api } from "./api";

export const apiContract = {
  getContractOptions: (contract_type) => {
    return api.get(`web/contracts/options`, { contract_type });
  },
  getStatistic: (contract_type_id) => {
    return api.get("web/contracts/statistic", { contract_type_id });
  },
  getContracts: (filter, page, size = 10) => {
    return api.post("web/contracts/filter", { filter, page, size });
  },

  //add new contract
  vehiclesSuggest: (number_plate, page) => {
    return api.post("web/vehicles/create_contract_suggestions", {
      number_plate,
      page,
    });
  },

  driverSuggest: (driver_name, page) => {
    ///drivers/create_contract_suggestions
    return api.post("web/drivers/create_contract_suggestions", {
      driver_name,
      page,
    });
  },

  driverSuggestContractWithout: (driver_name, page) => {
    ///drivers/create_contract_suggestions
    return api.post("web/drivers/create_contract_without_driver_suggestions", {
      driver_name,
      page,
    });
  },
  ///contracts/contract_code_suggestion
  contractCodeSuggest: (code_prefix, page, deleted) => {
    return api.post("web/contracts/contract_code_suggestion", {
      code_prefix,
      page,
      ...(!!deleted && { deleted: false }),
    });
  },

  ///contracts/create-contract-with-driver
  createContract: (payload) => {
    return api.post("web/contracts/create-contract-with-driver", {
      ...payload,
    });
  },

  ///contracts/create-contract-without-driver
  createContractWithoutDriver: (payload) => {
    return api.post("web/contracts/create-contract-without-driver", {
      ...payload,
    });
  },

  cancelContract: (id) => {
    return api.put(`web/contracts/cancel/${id}`);
  },

  deleteContract: (id) => {
    return api.delete(`web/contracts/delete/${id}`);
  },

  editImmediateContract: (params, contract_id) => {
    return api.put(
      `web/contracts/${contract_id}/edit-contract-with-driver-immediate`,
      { ...params }
    );
  },

  ///contracts/{contract_id}/edit-contract-without-driver-immediate
  editImmediateContractWithoutDriver: (params, contract_id) => {
    return api.put(
      `web/contracts/${contract_id}/edit-contract-without-driver-immediate`,
      { ...params }
    );
  },

  ///contracts/{contract_id}/edit-contract-without-driver-effective-date
  editEffectiveDateContractWithoutDriver: (params, contract_id) => {
    return api.put(
      `web/contracts/${contract_id}/edit-contract-without-driver-effective-date`,
      { ...params }
    );
  },

  ///contracts/{contract_id}/edit-contract-with-driver-effective-date
  editEffectiveDateContract: (params, contract_id) => {
    return api.put(
      `web/contracts/${contract_id}/edit-contract-with-driver-effective-date`,
      { ...params }
    );
  },

  getHistoryContract: (id, page) => {
    return api.get(`web/contracts/histories/${id}?page=${page}`);
  },

  // contract clone, create sub contract after create new contract
  cloneContract: (code_prefix, contract_type) => {
    return api.post("web/contracts/clone", { code_prefix, contract_type });
  },
  exportContract: async (
    filter,
    page,
    size,
    fileName = "Danh sách hợp đồng"
  ) => {
    return await api.postExcel("web/export/contracts", {
      filter,
      page,
      size,
      fileName,
    });
  },
};
